import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FaviconSwitchComponent } from 'src/app/shared/components/base-reset-password/favicon-switch.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-suguyaku-register-send',
  templateUrl: './suguyaku-register-send.component.html',
  styleUrls: [
    '../style/global.css',
    './suguyaku-register-send.component.css',
  ],
})
export class SuguyakuRegisterSendComponent
  extends FaviconSwitchComponent
  implements OnInit {
  initialized = false;
  constructor(private title: Title) {
    super();
  }

  ngOnInit(): void {
    this.title.setTitle(`認証用URL送信完了 | ${this.pageTitle}`);
    setTimeout(() => {
      this.initialized = true;
    }, 1000);
  }

  get isOem() {
    return /oem/g.test(environment.apps[this.clientId]?.type);
  }

  get pageTitle() {
    return environment.apps[this.clientId]?.pageTitle || '';
  }

  get oemId() {
    return environment.apps[this.clientId]?.oemConfig?.id;
  }
}
